import React        from 'react';

export default class BusinessReviews extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            reviews: [
                {
                    title: 'Тимур Бакшатов',
                    position: '',
                    desc: 'Никто из конкурентов даже близко не предлагает такого в Москве. Это уникально быстрый сервис.',
                    img: 'michelin'
                },
                {
                    title: 'Жанна Тухужева',
                    position: '',
                    desc: 'Водители замечательные, очень бережно относятся к грузу и следуют всем рекомендациям с пониманием.',
                    img: 'kidburg'
                },
                {
                    title: 'Антон Рыбин',
                    position: '',
                    desc: 'От раза к разу МУВЕР выступает с нами в единой сцепке, решая даже сверхсложные задачи в короткий срок',
                    img: 'dkgm'
                },
                {
                    title: 'Кристина Покрытан',
                    position: '',
                    desc: 'Выражаю бесконечную благодарность за поддержку нашего проекта и причастность к благородным делам.',
                    img: 'nuzhnapomosh'
                },
                {
                    title: 'Артем Тадэвосян',
                    position: '',
                    desc: 'Быстро подключились и уже на следующий день доставили в общей сложности 150 тонн груза, вы супер!',
                    img: 'fifa2018'
                }
            ],
            marginLeft: 0
        };

        this.timer = null;
    }

    componentDidMount() {
        let widthReview = 828;
        let allSize = 0 - (this.state.reviews.length - 1) * widthReview;
        this.timer = setInterval(() => {
            let canMove = this.state.marginLeft > allSize;

            this.setState({
                marginLeft: (canMove) ? this.state.marginLeft - widthReview : 0
            });
        }, 3000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    renderReviews = (item, index) => {
        return (
            <div className="reviews-item" key={index} data-index={index}>
                <div className="reviews-item-head">
                    <div className="reviews-item-brand">
						<div className={"img " + item.img}/>
                    </div>
                </div>
                <div className="reviews-item-text">
                    <p className="text">
                        <i className="quote t-left"/> {item.desc} <i className="quote t-right"/>
                    </p>
                </div>
                <div className="reviews-item-position">
                    <p className="title">{item.title}</p>
                </div>
            </div>
        )
    };

    render() {

        const { lang } = this.props;
        const { marginLeft , reviews } = this.state;

        return (
            <div className="s-index-reviews">
                <div className="reviews t-2">
                    <div className="reviews-wrapper" style={{marginLeft}}>
                        {reviews.map(this.renderReviews)}
                    </div>
                </div>
            </div>
        );
    }
}